import { differenceInDays } from "date-fns";

import { useState, useEffect } from "react";
import { getFreeTrialStatus } from "../api/subscriptionApi";

export const useFreeTrialStatus = () => {
  const [daysLeft, setDaysLeft] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [isPaidCustomer, setIsPaidCustomer] = useState(true);

  useEffect(() => {
    const fetchFreeTrialStatus = async () => {
      try {
        setIsLoading(true);
        const response = await getFreeTrialStatus();

        if (!response.freeTrialEndDate) {
          setIsPaidCustomer(true);
          setDaysLeft(null);
        } else {
          setIsPaidCustomer(false);
          const endDate = new Date(response.freeTrialEndDate);
          const today = new Date();
          const days = differenceInDays(endDate, today);
          setDaysLeft(Math.max(0, days));
        }
      } catch (err) {
        setError(
          err instanceof Error
            ? err
            : new Error("Failed to fetch free trial status")
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchFreeTrialStatus();
  }, []);

  return { daysLeft, isLoading, error, isPaidCustomer };
};
